import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Überprüft den Access Token vor jeder Anfrage
axiosInstance.interceptors.request.use(async (config) => {
  let accessToken = localStorage.getItem('access_token');
  let refreshToken = localStorage.getItem('refresh_token');

  if (accessToken) {
    const tokenData = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    if (tokenData.exp < currentTime) {
      try {
        // Hole neuen Access Token mit dem Refresh Token
        const response = await axios.post(`${baseURL}/token/refresh/`, {
          refresh: refreshToken,
        });

        // Speichere neuen Token
        localStorage.setItem('access_token', response.data.access);
        accessToken = response.data.access;
      } catch (error) {
        console.error('Token Refresh failed', error);
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login'; // Umleitung zur Login-Seite
      }
    }
  }

  config.headers['Authorization'] = accessToken ? `Bearer ${accessToken}` : null;
  return config;
});

// Response Interceptor: Fängt Fehler ab (z.B. wenn Refresh-Token ungültig ist)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized! Redirecting to login...');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login'; // Benutzer zur Login-Seite weiterleiten
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
